import { QUEUE_TYPE } from "@elixir/types";
import {
  addUhidToAppointment,
  queueFilterInlineSearchKeys,
  useFuseSearch,
} from "@elixir/utils";
import React from "react";
import { getFilteredAppointmentList } from "ui";
import useAllQueuesQuery from "../../apis/tryst/get-all-queues";
import useQueueStore from "../../stores/queue-store";
import LeftQueueContainer from "./left-queue-container";
import { getAptsForDoctor } from "../../utils/appointment-utils";

const FollowUps = () => {
  const { data, isLoading } = useAllQueuesQuery({
    queueType: "followupAppointments",
  });

  const leftQueueFilter = useQueueStore((state) => state.leftQueueFilter);
  const selectedDoctor = useQueueStore((state) => state.selectedDoctor);

  const _filteredData = React.useMemo(() => {
    return (
      getFilteredAppointmentList({
        appointments: getAptsForDoctor({
          apts: data?.followupAppointments || [],
          doctor_oid: selectedDoctor?.oid,
        }),
        queueFilter: leftQueueFilter,
        queueType: QUEUE_TYPE.FOLLOWUP,
      }) || []
    );
  }, [data?.followupAppointments, selectedDoctor?.oid, leftQueueFilter]);

  const leftSearchQuery = useQueueStore((state) => state.leftSearchQuery);
  const filteredApts =
    useFuseSearch(
      leftSearchQuery,
      addUhidToAppointment(_filteredData || []),
      queueFilterInlineSearchKeys
    ) || [];

  return (
    <LeftQueueContainer
      isLoading={isLoading}
      queueApts={filteredApts}
      queueType={QUEUE_TYPE.FOLLOWUP}
    />
  );
};

export default FollowUps;
